/*
 * Part of the RubinRed CMS.
 * @author    Paolo Pontarollo <pontarollo@workup.it>
 * @license   Proprietary
 * @copyright 2015-2018, Workup Srl
 * @link      http://rubinred.it
 */

export default class GeoLocation {
  constructor(withAddress = false) {
    this.status = 'empty';
    this.latitude = null;
    this.longitude = null;
    this.address = null;
    this.withAddress = withAddress;
  }

  //TODO: align method calls UI.Utils.human_distance => this.humanDistance;

  humanDistance(value) {
    return Intl.NumberFormat(App.locales.current, {maximumFractionDigits: 2}).format(value / 1000);
  }

  setLatLng(lat, lng) {
    this.latitude = lat;
    this.longitude = lng;

    this.status = 'localized';

    this.hydrateAddress();

    return this;
  }

  getLatitude() {
    this.checkIfInitialized();

    return this.latitude;
  }

  getLongitude() {
    this.checkIfInitialized();

    return this.longitude;
  }

  getAddress() {
    this.withAddress = true;
    this.checkIfInitialized();

    return this.address;
  }

  setAddress(address) {
    this.address = address;
    this.status = 'addressed';

    return this;
  }

  checkIfInitialized() {
    if(this.longitude === null || this.latitude === null) {
      this.getLocation();
    }
  }

  getLocation() {
    if (!this.loadPositionFromStorage()) {
      this.initializeGeoLocator();
    }
  }

  loadPositionFromStorage() {
    let storedPosition = localStorage.getItem('storedPosition');

    if (storedPosition) {
      storedPosition = JSON.parse(storedPosition);
      let hours = Math.floor(storedPosition.timestamp - new Date().getTime() / 60 * 60 * 1000);
      if (hours <= 2) {
        this.setLatLng(storedPosition.lat, storedPosition.lng);

        return true;
      }
    }

    return false;
  }

  storePosition() {
    localStorage.setItem('storedPosition', JSON.stringify({
      lat: this.getLatitude(),
      lng: this.getLongitude(),
      timestamp: new Date().getTime()
    }));

    return this;
  }

  loadAddressFromStorage() {
    let storedAddresses = localStorage.getItem('storedAddresses');
    if (!storedAddresses) {
      return false;
    }

    storedAddresses = JSON.parse(storedAddresses);
    let key = this.getLongitude() + ' ' + this.getLatitude();

    if (storedAddresses.hasOwnProperty(key)) {
      this.setAddress(storedAddresses[key]);

      return true;
    }

    return false;
  }

  storeAddress() {
    let storedAddresses = localStorage.getItem('storedAddresses'),
      key = this.getLongitude() + ' ' + this.getLatitude();

    if (!storedAddresses) {
      storedAddresses = {};
    } else {
      storedAddresses = JSON.parse(storedAddresses);
    }

    storedAddresses[key] = this.getAddress();

    localStorage.setItem('storedAddresses', JSON.stringify(storedAddresses));
  }

  initializeGeoLocator() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.handleLocalizeSuccess(position.coords);
      }, () => {
        // The GeoLocation service failed
        this.handleLocalizeFailed();
      });
    } else {
      // No GeoLocation service
      this.handleLocalizeFailed();
    }

    return this;
  }

  handleLocalizeFailed() {
    window.App.$emit('geolocation.failed', this);
  }

  handleLocalizeSuccess(coords) {
    this.setLatLng(coords.latitude, coords.longitude).storePosition();

    window.App.$emit('geolocation.completed', this);
  }

  hydrateAddress() {
    if (!this.withAddress) {
      return;
    }
    if (!this.loadAddressFromStorage()) {
      this.retrieveAddress();
    }
  }

  retrieveAddress() {
    let latitude = this.getLatitude(),
      longitude = this.getLongitude(),
      address = latitude + ', ' + longitude,
      latlng = new google.maps.LatLng(latitude, longitude),
      geocoder = new google.maps.Geocoder();

    geocoder.geocode({'latLng': latlng}, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[1]) {
          address = results[1].formatted_address;
          this.setAddress(address);
          this.storeAddress();

          window.App.$emit('geolocation.addressed', this);
        }
      }
    });
  }
}

window.App.Utils.GeoLocation = new GeoLocation();



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/location/assets/js/GeoLocation.js